import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Teaching from "../pages/teaching/page";
import Courses from "../pages/courses/page";
import Instrument from "../pages/instrument/page";
import Contact from "../pages/contact/page";
import Notes from "../pages/notes/page";
import ArticlePage from "../pages/notes/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/teaching",
    element: <Teaching />,
  },
  {
    path: "/courses",
    element: <Courses />,
  },
  {
    path: "/instrument",
    element: <Instrument />,
  },
  {
    path: "/notes",
    element: <Notes />,
  },
  {
    path: "/notes/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
